import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import AdminFullTable from '../../components/AdminFullTable';
import axios from 'axios';
import * as XLSX from 'xlsx';
import '../../Styles/Admin/ManageNominations.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API_BASE_URL from '../../config';
import '../../axios_overrite';

function NominationModal({ open, onClose, onSubmit, initialData }) {
  const [form, setForm] = useState({
    id: '', first_name: '', last_name: '', role: '', email: '', mobile: '',
    company_name: '', type_of_company: '', headquarters: '', industry: '',
    num_employees: '', how_heard: '', terms_accepted: 0
  });

  useEffect(() => {
    if (initialData) {
      setForm({
        id: initialData.id || '',
        first_name: initialData.first_name || '',
        last_name: initialData.last_name || '',
        role: initialData.role || '',
        email: initialData.email || '',
        mobile: initialData.mobile || '',
        company_name: initialData.company_name || '',
        type_of_company: initialData.type_of_company || '',
        headquarters: initialData.headquarters || '',
        industry: initialData.industry || '',
        num_employees: initialData.num_employees || '',
        how_heard: initialData.how_heard || '',
        terms_accepted: initialData.terms_accepted || 0
      });
    } else {
      setForm({
        id: '', first_name: '', last_name: '', role: '', email: '', mobile: '',
        company_name: '', type_of_company: '', headquarters: '', industry: '',
        num_employees: '', how_heard: '', terms_accepted: 0
      });
    }
  }, [initialData, open]);

  if (!open) return null;

  return (
    <div className="nom-admin-modal-overlay">
      <div className="nom-admin-modal-content">
        <div className="nom-admin-modal-header">
          <h3 className="nom-admin-modal-title">{initialData ? 'Edit Nomination' : 'Add Nomination'}</h3>
          <button className="nom-admin-modal-close" onClick={onClose} aria-label="Close">&times;</button>
        </div>
        <form onSubmit={e => { e.preventDefault(); onSubmit(form); }}>
          <div className="nom-admin-modal-fields-grid">
            <div>
              <label>First Name :
                <input type="text" value={form.first_name} onChange={e => setForm({ ...form, first_name: e.target.value })} required />
              </label>
              <label>Last Name :
                <input type="text" value={form.last_name} onChange={e => setForm({ ...form, last_name: e.target.value })} required />
              </label>
              <label>Role
                <input type="text" value={form.role} onChange={e => setForm({ ...form, role: e.target.value })} />
              </label>
              <label>Email
                <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
              </label>
              <label>Mobile
                <input type="text" value={form.mobile} onChange={e => setForm({ ...form, mobile: e.target.value })} />
              </label>
              <label>Company Name
                <input type="text" value={form.company_name} onChange={e => setForm({ ...form, company_name: e.target.value })} />
              </label>
            </div>
            <div>
              <label>Type of Company :
                <input type="text" value={form.type_of_company} onChange={e => setForm({ ...form, type_of_company: e.target.value })} />
              </label>
              <label>Headquarters
                <input type="text" value={form.headquarters} onChange={e => setForm({ ...form, headquarters: e.target.value })} />
              </label>
              <label>Industry
                <input type="text" value={form.industry} onChange={e => setForm({ ...form, industry: e.target.value })} />
              </label>
              <label>Number of Employees
                <input type="text" value={form.num_employees} onChange={e => setForm({ ...form, num_employees: e.target.value })} />
              </label>
              <label>How Heard
                <input type="text" value={form.how_heard} onChange={e => setForm({ ...form, how_heard: e.target.value })} />
              </label>
              <label>Terms Accepted
                <select value={form.terms_accepted} onChange={e => setForm({ ...form, terms_accepted: Number(e.target.value) })}>
                  <option value={1}>Yes</option>
                  <option value={0}>No</option>
                </select>
              </label>
            </div>
          </div>
          <div className="nom-admin-modal-actions">
            <button type="button" className="nom-admin-secondary-btn" onClick={onClose}>Cancel</button>
            <button type="submit" className="nom-admin-primary-btn">{initialData ? 'Save changes' : 'Add Nomination'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

function DeleteConfirmModal({ open, onCancel, onConfirm }) {
  if (!open) return null;
  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal-content">
        <div className="delete-modal-icon">⚠️</div>
        <h2 className="delete-modal-title">Delete Information</h2>
        <div className="delete-modal-desc">This Record will be deleted</div>
        <div className="delete-modal-actions">
          <button className="delete-modal-cancel" onClick={onCancel}>No, Keep it</button>
          <button className="delete-modal-confirm" onClick={onConfirm}>Yes, Delete</button>
        </div>
      </div>
    </div>
  );
}

export default function ManageNominations({
  paginationPosition = "bottom-right",
  searchPosition = "top-right"
}) {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(25);
  const [modalOpen, setModalOpen] = useState(false);
  const [editNom, setEditNom] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [exporting, setExporting] = useState(false);

  useEffect(() => { fetchData(); /* eslint-disable-next-line */ }, [page, search, limit]);

  const fetchData = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/nominations?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`);
      setData(res.data.nominations || []);
      setTotal(res.data.total || 0);
    } catch {
      setData([]); setTotal(0);
    }
  };

  const handleUpdate = async (nom) => {
    await axios.post(`${API_BASE_URL}/api/nominations/edit/${nom.id}`, nom);
    setModalOpen(false); setEditNom(null); fetchData();
    toast.success('Nomination updated successfully!');
  };

  const handleDeleteClick = (id) => { setDeleteId(id); setDeleteModalOpen(true); };
  const handleDeleteConfirm = async () => {
    await axios.post(`${API_BASE_URL}/api/nominations/delete/${deleteId}`);
    setDeleteModalOpen(false); setDeleteId(null); fetchData();
    toast.success('Nomination deleted successfully!');
  };
  const handleDeleteCancel = () => { setDeleteModalOpen(false); setDeleteId(null); };

  // ── Export to a real .xlsx file (built client-side with SheetJS) ──
  const handleExport = async () => {
    setExporting(true);
    try {
      // Pull ALL matching rows (not just the current page) so the Excel file
      // reflects the full search result, same as the old CSV export did.
      const res = await axios.get(
        `${API_BASE_URL}/api/nominations?page=1&limit=100000&search=${encodeURIComponent(search)}`
      );
      const rows = res.data.nominations || [];

      if (rows.length === 0) {
        toast.info('No records to export.');
        setExporting(false);
        return;
      }

      // Shape the rows into clean, human-readable columns for Excel
      const excelRows = rows.map((row, index) => ({
        'ID': index + 1,
        'First Name': row.first_name || '',
        'Last Name': row.last_name || '',
        'Role': row.role || '',
        'Contact Email': row.email || '',
        'Mobile': row.mobile || '',
        'Company Name': row.company_name || '',
        'Type Of Company': row.type_of_company || '',
        'Headquarters': row.headquarters || '',
        'Industry': row.industry || '',
        'Number of Employees': row.num_employees || '',
        'How Heard': row.how_heard || '',
        'Terms Accepted': row.terms_accepted ? 'Yes' : 'No',
        'Created At': row.created_at ? row.created_at.slice(0, 10) : ''
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelRows);

      // Reasonable column widths so it's readable on open
      worksheet['!cols'] = [
        { wch: 6 },  { wch: 16 }, { wch: 16 }, { wch: 18 }, { wch: 26 },
        { wch: 16 }, { wch: 24 }, { wch: 18 }, { wch: 20 }, { wch: 16 },
        { wch: 18 }, { wch: 18 }, { wch: 14 }, { wch: 14 }
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Nominations');

      XLSX.writeFile(workbook, 'nominations.xlsx');
      toast.success('Excel file downloaded!');
    } catch (err) {
      toast.error('Export failed. Please try again.');
    } finally {
      setExporting(false);
    }
  };

  const tableColumns = [
    { label: 'S.NO', key: 'id', width: 50 },
    { label: 'First Name', key: 'first_name', width: 120 },
    { label: 'Last Name', key: 'last_name', width: 120 },
    { label: 'Role', key: 'role', width: 140 },
    { label: 'Contact Email', key: 'email', width: 180 },
    { label: 'Mobile', key: 'mobile', width: 120 },
    { label: 'Company Name', key: 'company_name', width: 180 },
    { label: 'Type Of Company', key: 'type_of_company', width: 140 },
    { label: 'Headquarters', key: 'headquarters', width: 160 },
    { label: 'Industry', key: 'industry', width: 120 },
    { label: 'Number of Employees', key: 'num_employees', width: 120 },
    { label: 'How Heard', key: 'how_heard', width: 140 },
    { label: 'Terms Accepted', key: 'terms_accepted', width: 110 },
    { label: 'Created At', key: 'created_at', width: 160 },
  
    { label: 'Actions', key: 'actions', width: 120 }
  ];

  const tableData = data.map((row, index) => ({
    ...row,
    id: (page - 1) * limit + index + 1,
    terms_accepted: row.terms_accepted ? 'Yes' : 'No',
     created_at: row.created_at ? row.created_at.slice(0, 10) : '',
    actions: (
<div className="nom-admin-actions">
  <button className="nom-admin-edit-btn" onClick={() => { setEditNom(row); setModalOpen(true); }}>
    <img src="/edit-filled.png" alt="edit" className="nom-admin-action-icon" />
  </button>
  <button className="nom-admin-delete-btn" onClick={() => handleDeleteClick(row.id)}>
    <img src="/delete-fill.png" alt="delete" className="nom-admin-action-icon" />
  </button>
</div>
    )
  }));

  const totalPages = Math.ceil(total / limit);
  const visiblePages = [];
  for (let i = 1; i <= totalPages && i <= 5; i++) visiblePages.push(i);

  return (
    <AdminLayout title="Nominations" subtitle="Forms and Submissions">
      <div className="nom-admin-section">
        <div className="nom-admin-container">
          <div className="nom-admin-table-header">
            <div className="nom-admin-table-header-left">
              <div className="nom-admin-show-entries">
                <label htmlFor="show-entries" className="nom-admin-show-entries-label">Show Entries :</label>
                <select id="show-entries" value={limit} onChange={e => { setLimit(Number(e.target.value)); setPage(1); }} className="nom-admin-show-entries-select">
                  {[10, 25, 50, 100].map(opt => <option key={opt} value={opt}>{opt}</option>)}
                </select>
              </div>
            </div>
          </div>

          <div className="nom-admin-search-and-stats">
            <div className="nom-admin-search-wrapper">
              <input type="text" placeholder="Search..." value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} className="nom-admin-table-search" />
              <span className="nom-admin-search-icon"><img src="/icons/search.png" alt="search" /></span>
            </div>
            <div className="nom-admin-stats-group">
              <span className="nom-admin-count-badge">Total Count : {total}</span>
              <button className="nom-admin-export-btn" onClick={handleExport} disabled={exporting}>
                <img src="/icons/excel.png" alt="Export" />
                {exporting ? 'Exporting...' : 'Export To Excel'}
              </button>
            </div>
          </div>

          <div className="nom-admin-table-wrapper">
            <AdminFullTable columns={tableColumns} data={tableData} tableClass="nom-admin-table nom-admin-table-small" />
            <div className="nom-admin-table-footer">
              <div className="nom-admin-info">
                {total > 0 ? `Showing ${((page - 1) * limit) + 1} to ${Math.min(page * limit, total)} of ${total} entries` : 'Showing 0 to 0 of 0 entries'}
              </div>
              <div className="nom-admin-pagination">
                <button disabled={page === 1} onClick={() => setPage(page - 1)} className="nom-admin-page-btn">‹</button>
                {visiblePages.map(pageNum => (
                  <button key={pageNum} onClick={() => setPage(pageNum)} className={`nom-admin-page-btn${page === pageNum ? ' active' : ''}`}>{pageNum}</button>
                ))}
                {totalPages > 5 && (
                  <>
                    <span className="nom-admin-page-btn" style={{ cursor: 'default' }}>…</span>
                    <button onClick={() => setPage(totalPages)} className={`nom-admin-page-btn${page === totalPages ? ' active' : ''}`}>{totalPages}</button>
                  </>
                )}
                <button disabled={page === totalPages || total === 0} onClick={() => setPage(page + 1)} className="nom-admin-page-btn">›</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <NominationModal open={modalOpen} onClose={() => { setModalOpen(false); setEditNom(null); }} onSubmit={handleUpdate} initialData={editNom} />
      <DeleteConfirmModal open={deleteModalOpen} onCancel={handleDeleteCancel} onConfirm={handleDeleteConfirm} />
      <ToastContainer position="top-right" autoClose={3000} />
    </AdminLayout>
  );
}